import { notify } from '@/utils';
import { FC, ReactNode, useEffect } from 'react';
import { GlobalStyles } from '@mui/material';
import { SnackbarProvider, enqueueSnackbar } from 'notistack';
import { NotificationSnackbar } from './snackbar-content';

export const NotificationsProvider: FC<{ children?: ReactNode }> = ({ children }) => {
	useEffect(() => {
		notify.enable(
			(message: string) => enqueueSnackbar(message, { variant: 'error' }),
			(message: string) => enqueueSnackbar(message, { variant: 'warning' }),
			(message: string) => enqueueSnackbar(message, { variant: 'info' }),
			(message: string) => enqueueSnackbar(message, { variant: 'success' })
		);
	}, []);

	return (
		<>
			<GlobalStyles
				styles={{
					'.gp-snackbar-bottom-right, .gp-snackbar-bottom-center, .gp-snackbar-bottom-left':
						{
							flexDirection: 'column'
						}
				}}
			/>
			{/* copiii TREBUIE randați ÎN INTERIORUL SnackbarProvider — contextul implicit
				notistack e un no-op, deci orice useSnackbar() din afara provider-ului
				„afișează" toast-uri care nu apar niciodată (ex. duplicarea de proiecte) */}
			<SnackbarProvider
				autoHideDuration={7000}
				preventDuplicate
				anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
				maxSnack={5}
				classes={{
					containerAnchorOriginBottomRight: 'gp-snackbar-bottom-right',
					containerAnchorOriginBottomCenter: 'gp-snackbar-bottom-center',
					containerAnchorOriginBottomLeft: 'gp-snackbar-bottom-left'
				}}
				Components={{
					success: NotificationSnackbar,
					error: NotificationSnackbar,
					warning: NotificationSnackbar,
					info: NotificationSnackbar,
					default: NotificationSnackbar
				}}
			>
				{children}
			</SnackbarProvider>
		</>
	);
};

NotificationsProvider.defaultProps = {
	children: undefined
};
